import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Shown instead of empty charts/widgets when the user lacks the required permission.
 */
export function PermissionRequiredPlaceholder({ minHeight = 320, message = 'Permission required' }) {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    return (
        <Box
            data-testid='permission-required-placeholder'
            sx={{
                position: 'relative',
                minHeight,
                borderRadius: 1,
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                px: 3,
                py: 4,
                border: `1px dashed ${theme.palette.divider}`,
                bgcolor: alpha(theme.palette.text.primary, 0.03),
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    opacity: isDark ? 0.04 : 0.06,
                    backgroundImage: `repeating-linear-gradient(
                        -35deg,
                        transparent,
                        transparent 14px,
                        ${theme.palette.text.primary} 14px,
                        ${theme.palette.text.primary} 15px
                    )`,
                    pointerEvents: 'none',
                },
            }}
        >
            <Typography
                variant='body2'
                color='text.secondary'
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontWeight: 500,
                    letterSpacing: '0.02em',
                }}
            >
                <LockOutlinedIcon sx={{ fontSize: 20, opacity: 0.85 }} aria-hidden />
                {message}
            </Typography>
        </Box>
    );
}

PermissionRequiredPlaceholder.propTypes = {
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    message: PropTypes.string,
};
